(function () {
  var bar = document.getElementById('ffl-sticky-atc');
  if (!bar) return;
  var totalEl = bar.querySelector('[data-sticky-total]');
  var noteEl = bar.querySelector('[data-sticky-note]');

  function parseMoney(text) {
    var m = (text || '').replace(/,/g, '').match(/£\s*(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }

  function basePrice() {
    // The selected-variant JSON is the only price source the Expo app
    // never rewrites (it mutates the visible price to include extras).
    var json = document.querySelector('variant-selects [data-selected-variant]');
    if (json) {
      try {
        return JSON.parse(json.textContent).price / 100;
      } catch (e) {
        /* fall through to DOM parse */
      }
    }
    var el =
      document.querySelector('.product__info-container .price__sale .price-item--sale:not(.expo-changed)') ||
      document.querySelector('.product__info-container .price__regular .price-item--regular:not(.expo-changed)');
    return parseMoney(el && el.textContent);
  }

  function extrasTotal() {
    var sum = 0;
    document.querySelectorAll('.expo-choice-list__option-label input:checked').forEach(function (input) {
      var label = input.closest('.expo-choice-list__option-label');
      var price = label && label.querySelector('.expo-option-extra-price');
      var value = parseMoney(price && price.textContent);
      if (value) sum += value;
    });
    return sum;
  }

  /* Old sofa removal (snippets/sofa-removal.liquid). One price per order,
     never multiplied by quantity — same footing as the Expo extras. */
  function selectedRemovalCard() {
    return document.querySelector('[data-ffl-removal-card].ffl-removal__card--on');
  }
  function removalPrice() {
    var card = selectedRemovalCard();
    return card ? parseInt(card.getAttribute('data-price'), 10) / 100 : 0;
  }

  function quantity() {
    var input = document.querySelector('.product-form__input input[name="quantity"], quantity-input input');
    var n = input ? parseInt(input.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function updateTotal() {
    var base = basePrice();
    if (base === null) return;
    var extras = extrasTotal() + removalPrice();
    var total = base * quantity() + extras;
    totalEl.textContent = formatMoney(total);
    noteEl.hidden = extras === 0;
  }

  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var mainButton = document.querySelector('.product-form__submit');
        if (mainButton) bar.hidden = mainButton.getBoundingClientRect().bottom >= 0;
      });
    },
    { passive: true }
  );

  document.addEventListener('change', updateTotal);
  document.addEventListener('click', function () {
    setTimeout(updateTotal, 50);
  });
  updateTotal();

  /* Add-on cards over the Expo app's Yes/No radios. The app's own UI is
     hidden once cards are built and every card tap clicks the matching
     radio underneath, so the app still applies fees to the cart. If the
     app's markup ever changes shape, cards don't build and its original
     UI stays visible. */
  /* Card text is the app's own question, verbatim. These short names are
     only for the "incl. …" note, where the full question won't fit. */
  var ADDON_NOTE_NAMES = [
    { match: 'care kit', name: 'luxury care kit' },
    { match: 'set the item up', name: 'setup' },
  ];

  function selectedAddonNames() {
    var names = Array.prototype.slice
      .call(document.querySelectorAll('.ffl-addon.ffl-addon--on'))
      .map(function (el) { return el.getAttribute('data-ffl-name'); });
    if (selectedRemovalCard()) names.push('sofa removal');
    return names;
  }

  function updateAtcLabel() {
    var span = document.querySelector('.product-form__submit > span');
    if (!span) return;
    if (/sold out/i.test(span.textContent)) return;
    var base = basePrice();
    if (base === null) return;
    var total = base * quantity() + extrasTotal() + removalPrice();
    span.textContent = 'Add to cart (' + formatMoney(total) + ')';
    var names = selectedAddonNames();
    noteEl.textContent = names.length ? 'incl. ' + names.join(' + ') : '';
    noteEl.hidden = names.length === 0;
  }

  function buildAddonCards(builder) {
    var wrappers = builder.querySelectorAll('.expo-element-wrapper[data-element-type="radio"]');
    if (!wrappers.length) return;
    var container = document.createElement('div');
    container.className = 'ffl-addons';
    var heading = document.createElement('p');
    heading.className = 'ffl-addons__heading';
    heading.textContent = 'Popular add-ons';
    container.appendChild(heading);
    var built = 0;

    wrappers.forEach(function (wrapper) {
      var labelText = (wrapper.querySelector('.expo-element-label') || {}).textContent || '';
      var options = wrapper.querySelectorAll('.expo-choice-list__option-label');
      var yesInput = null;
      var noInput = null;
      var priceText = null;
      options.forEach(function (opt) {
        var input = opt.querySelector('input[type="radio"]');
        if (/^yes/i.test(opt.textContent.trim())) {
          yesInput = input;
          var price = opt.querySelector('.expo-option-extra-price');
          priceText = price && price.textContent.replace(/[()]/g, '').trim();
        } else if (/^no/i.test(opt.textContent.trim())) {
          noInput = input;
        }
      });
      if (!yesInput || !noInput || !priceText) return;

      var noteName = labelText.trim().toLowerCase().replace(/\?$/, '');
      ADDON_NOTE_NAMES.forEach(function (c) {
        if (labelText.toLowerCase().indexOf(c.match) !== -1) noteName = c.name;
      });

      var card = document.createElement('div');
      card.className = 'ffl-addon';
      card.setAttribute('role', 'checkbox');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-checked', 'false');
      card.setAttribute('data-ffl-name', noteName);
      card.innerHTML =
        '<span class="ffl-addon__tick" aria-hidden="true"></span>' +
        '<span class="ffl-addon__text"><span class="ffl-addon__title"></span></span>' +
        '<span class="ffl-addon__price"></span>';
      card.querySelector('.ffl-addon__title').textContent = labelText.trim();
      card.querySelector('.ffl-addon__price').textContent = priceText;

      function setState(on) {
        card.classList.toggle('ffl-addon--on', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        var target = on ? yesInput : noInput;
        if (!target.checked) target.click();
        updateTotal();
        updateAtcLabel();
      }
      card.addEventListener('click', function () {
        setState(!card.classList.contains('ffl-addon--on'));
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          card.click();
        }
      });
      if (yesInput.checked) setState(true);

      container.appendChild(card);
      built++;
    });

    if (!built) return;
    builder.parentNode.insertBefore(container, builder);
    builder.classList.add('ffl-addons-built');
  }

  /* The Expo app rewrites the headline price to include extras. That price
     is the sofa's alone — the combined total lives in the buy button and
     sticky bar — so put it back whenever the app changes it. */
  function formatMoney(n) {
    var s = Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2);
    return '£' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function pinHeadlinePrice() {
    // Expo has marked the inner price item or, more recently, the whole
    // .price div (which it flattens to bare text) — handle both.
    var el =
      document.querySelector('.product__info-container .price-item--last.expo-changed') ||
      document.querySelector('.product__info-container .price.expo-changed');
    if (!el) return;
    var base = basePrice();
    if (base === null) return;
    var wanted = formatMoney(base);
    if (el.textContent.trim() !== wanted) el.textContent = wanted;
  }
  var priceContainer = document.querySelector('.product__info-container .price');
  if (priceContainer && 'MutationObserver' in window) {
    new MutationObserver(pinHeadlinePrice).observe(priceContainer, {
      childList: true,
      characterData: true,
      subtree: true,
    });
    pinHeadlinePrice();
  }

  /* Expo re-renders its widget at will (fresh .expo-builder node, so the
     ffl-addons-built marker is lost and raw radios reappear) — watch
     indefinitely and rebuild the cards over each new render. */
  setInterval(function () {
    var builder = document.querySelector('.expo-builder:not(.ffl-addons-built)');
    if (!builder || !builder.querySelector('.expo-choice-list__option-label input')) return;
    document.querySelectorAll('.ffl-addons').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    buildAddonCards(builder);
    updateAtcLabel();
  }, 400);

  document.addEventListener('change', updateAtcLabel);

  /* Removal tier cards: one selectable at a time, tap again to deselect. */
  function setRemovalCard(card, on) {
    document.querySelectorAll('[data-ffl-removal-card]').forEach(function (c) {
      c.classList.remove('ffl-removal__card--on');
      c.setAttribute('aria-checked', 'false');
    });
    if (on) {
      card.classList.add('ffl-removal__card--on');
      card.setAttribute('aria-checked', 'true');
    }
    updateRemovalSummary();
    updateTotal();
    updateAtcLabel();
  }
  function updateRemovalSummary() {
    var state = document.querySelector('[data-ffl-removal-state]');
    if (!state) return;
    if (!state.getAttribute('data-default')) state.setAttribute('data-default', state.textContent);
    var card = selectedRemovalCard();
    if (card) {
      var title = card.querySelector('.ffl-removal__title');
      state.textContent = (title ? title.textContent : '') + ' (' + formatMoney(removalPrice()) + ')';
      state.classList.add('ffl-removal__summary-state--on');
    } else {
      state.textContent = state.getAttribute('data-default');
      state.classList.remove('ffl-removal__summary-state--on');
    }
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest('[data-ffl-removal-card]');
    if (!card) return;
    setRemovalCard(card, !card.classList.contains('ffl-removal__card--on'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var card = e.target.closest && e.target.closest('[data-ffl-removal-card]');
    if (!card) return;
    e.preventDefault();
    setRemovalCard(card, !card.classList.contains('ffl-removal__card--on'));
  });

  /* The removal service is its own product, so it can't ride the product
     form. Once the sofa lands in the basket, bring the basket in line with
     the selection: at most one removal line, quantity 1, matching tier. */
  function syncRemovalToCart() {
    var ids = Array.prototype.map.call(
      document.querySelectorAll('[data-ffl-removal-card]'),
      function (c) { return parseInt(c.getAttribute('data-variant-id'), 10); }
    );
    if (!ids.length) return;
    var wanted = selectedRemovalCard();
    var wantedId = wanted ? parseInt(wanted.getAttribute('data-variant-id'), 10) : null;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var have = false;
        cart.items.forEach(function (item) {
          if (ids.indexOf(item.variant_id) === -1) return;
          if (item.variant_id === wantedId) {
            have = true;
            if (item.quantity !== 1) updates[item.variant_id] = 1;
          } else {
            updates[item.variant_id] = 0;
          }
        });
        var chain = Promise.resolve();
        if (Object.keys(updates).length) {
          chain = chain.then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates }),
            });
          });
        }
        if (wantedId && !have) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: wantedId, quantity: 1 }] }),
            });
          });
        }
        return chain;
      });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.source === 'product-form') syncRemovalToCart();
    });
  }
})();
